<template>
  <h4>Manage Your Policy</h4>
  <p>
    To file a claim or manage your policy, visit the website of the appropriate
    insurer.
  </p>
  <hr />
  <br />
  <div class="managepolicy-bucket">
    <strong>Renters Insurance</strong><br />
    <img
      :src="require('@/assets/images/managepolicy-assurant.png')"
      style="max-width:340px;width='100%';height='auto';"
      alt="Manage Policy Assurant"
    /><br /><br />
    <button @click="openAssurantLink()">My Assurant Policy</button>
  </div>
  <div class="managepolicy-bucket">
    <strong>Accidental Damage Personal Property Coverage</strong><br />
    <img
      :src="require('@/assets/images/managepolicy-nssi.png')"
      style="max-width:260px;width='100%';height='auto'"
      alt="Manage Policy NSSI"
    /><br /><br />
    <button @click="openNssiLink()">NSSI Customer Area</button>
  </div>
  <div style="clear: both"></div>
</template>
<script lang="ts" setup>
import { links } from "@/utils/Links";

//TODO url read from const file
function openAssurantLink() {
  window.open(links.MY_ASSURANT_POLICY, "_blank");
}
function openNssiLink() {
  window.open(links.CUSTOMER_ACCOUNT_LOGIN, "_blank");
}
</script>
